import PropTypes from 'prop-types';
import {Link} from 'react-router';

const YOUTUBE_ICON_URL = 'https://d13e30dasa2fhv.cloudfront.net/oral_hyglene_supplier/youtube60x60.jpg';

export default function DentalKnowledgeList(props) {
  return (
    <li>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          padding: '14px 16px',
          borderRadius: '16px',
          background: 'rgba(255,255,255,0.85)',
          backdropFilter: 'blur(20px) saturate(160%)',
          WebkitBackdropFilter: 'blur(20px) saturate(160%)',
          border: '1px solid #E5E7EB',
          boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
          transition: 'box-shadow 150ms ease-out',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.08)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
        }}
      >
        {/* Thumbnail */}
        <Link to={`./${props.id}`} style={{flexShrink: 0, width: '128px'}}>
          <img
            src={props.image}
            alt={props.title || 'Dental education cover'}
            loading="lazy"
            style={{
              borderRadius: '12px',
              objectFit: 'cover',
              display: 'block',
              aspectRatio: '16 / 10',
              width: '100%',
              height: 'auto',
            }}
          />
        </Link>

        {/* Title */}
        <div style={{flex: 1, minWidth: 0}}>
          <Link to={`./${props.id}`} style={{textDecoration: 'none'}}>
            <h4
              style={{
                margin: 0,
                fontFamily: 'var(--font-display), Outfit, system-ui',
                fontSize: '15px',
                fontWeight: 600,
                color: '#1A1A2E',
                lineHeight: 1.35,
                wordBreak: 'break-word',
              }}
            >
              {props.title}
            </h4>
          </Link>
        </div>

        {/* YouTube Icon */}
        <div style={{flexShrink: 0}}>
          <Link
            to={`./${props.id}#videos`}
            style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
          >
            <img
              src={YOUTUBE_ICON_URL}
              alt="Watch Video"
              style={{width: '48px', height: '48px', borderRadius: '8px', objectFit: 'contain'}}
            />
          </Link>
        </div>
      </div>
    </li>
  );
}

DentalKnowledgeList.propTypes = {
  id: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
  date: PropTypes.string,
};
